import { render, staticRenderFns } from "./TemplateClone.vue?vue&type=template&id=0a387859&scoped=true"
import script from "./TemplateClone.vue?vue&type=script&lang=js"
export * from "./TemplateClone.vue?vue&type=script&lang=js"
import style0 from "./TemplateClone.vue?vue&type=style&index=0&id=0a387859&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a387859",
  null
  
)

export default component.exports